import PageLayout from './HomePageLayout'

export default PageLayout
